<template>
  <quote-builder-labour-item-template :is-full-width="isFullWidth"
    :is-header="true"
    :is-quote-hour="isQuoteHour"
    class="bb-grey-1 pb-2 mb-2 quote-item-heading"
    :class="`quote-item-heading-${$theme.name}`">
    <template v-slot:description>
      <div class="is-flex is-align-items-center">
        <span>{{ name }}</span>
        <span class="ml-2">({{ count }})</span>
        <!-- <span class=" ml-5 is-size-6 has-background-primary has-text-white px-2 is-rounded">
          {{ count }}
        </span> -->
      </div>
    </template>

    <template v-slot:rates>
      <div class="is-flex is-justify-content-end is-align-items-center mx-2 ">
        <span v-if="count >= 1">Rate</span>
      </div>
    </template>

    <template v-slot:report>
      <div class="is-flex is-align-items-center ">
        <span v-if="false">Rpt</span>
      </div>
    </template>    <template v-slot:hour_value>
      <div class="is-flex is-justify-content-end is-align-items-center ">
        <span v-if="count >= 1">{{ isQuoteHour ? hourValue.toFixed(2) : 'Value' }}</span>
      </div>
    </template>

    <template v-slot:total_value>
      <div class="is-flex is-justify-content-end is-align-items-center">
        <span v-if="count >= 1"> {{ $filters.formatCurrency(totalValue, $userInfo.locale) }}</span>
      </div>
    </template>

    <template v-slot:present_as>
      <div class="is-flex is-justify-content-center is-align-items-center">
        <span v-if="false">Present As</span>
      </div>
    </template>
  </quote-builder-labour-item-template>
</template>

<script>
import QuoteBuilderLabourItemTemplate from '@/views/quote/quoteBuilder/templates/QuoteBuilderLabourItemTemplate.vue'

export default {
  name: 'QuoteBuilderOtherLabourHeadingsComponent',
  components: {
    QuoteBuilderLabourItemTemplate
  },
  props: {
    name: {
      type: String,
      required: true
    },
    isFullWidth: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 0
    },    totalValue: {
      type: Number,
      default: 0
    },
    hourValue: {
      type: Number,
      default: 0
    },
    isQuoteHour: {
      type: Boolean,
      default: false
    }
  }
  // Your component's logic goes here
}
</script>

<style scoped>
/* Your component's styles go here */
</style>